@if (isVisible) {
  <div class="grid-y">
    <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
    @for (item of items; track item) {
      <div class="checkbox">
        <input class="show-for-sr" type="checkbox" [id]="controlId + '-' + item[componentData.config.idProperty]"
          [checked]="item.checked" [disabled]="formGroup.controls[componentData.key].disabled" (change)="updateContextValue(item, $event)" />
          <label [for]="controlId + '-' + item[componentData.config.idProperty]">
            <span class="checkbox-box" aria-hidden="true"><span class="checkbox-check" aria-hidden="true">&#x2714;</span></span>
            {{item[componentData.config.displayProperty]}}
          </label>
        </div>
      }
    </div>
  }